// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9db364fe","455":"40f0d9ca","977":"bf4e6efd"}[chunkId] + ".chunk.js";
};